import { MouseEventHandler } from "react";
import { Box, Link } from "@mui/material";
import { ISearchUnderlying } from "src/api/client/search-autocomplete.api.types";
import { Highlight } from "src/components/common/highlight";
import { Typography } from "src/components-mui/base/typography/typography";
import { SearchItemLogo } from "src/components-mui/common/typeahead/nav-search-item/shared/search-item-logo";
import { getNavSearchItemStyles } from "src/components-mui/common/typeahead/nav-search-item/shared/styles";
import { UnderlyingBadge } from "src/components-mui/common/typeahead/nav-search-item/shared/underlying-badge";
import { IPlacement } from "src/components-mui/common/typeahead/typeahead.types";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { getTrackingUrlParam } from "src/utils/search-tracking-util";

const NAV_UNDERLYING_SEARCH_ITEM_TEST_ID = "nav-underlying-search-item";

interface IUnderlyingSearchItem {
    isSelected?: boolean;
    query?: string;
    placement: IPlacement;
    showBadge?: boolean;
    onClick?: MouseEventHandler;
}

export const UnderlyingSearchItem = ({
    resourceIdentifier,
    shortDescription,
    securityType,
    logoUrl,
    isSelected = false,
    query,
    placement,
    showBadge = true,
    onClick,
}: ISearchUnderlying & IUnderlyingSearchItem) => {
    const { buildUnderlyingLink } = useLinkBuilder();

    return (
        <Link
            href={buildUnderlyingLink(resourceIdentifier) + getTrackingUrlParam({ placement, query })}
            onClick={onClick}
            data-test-id={NAV_UNDERLYING_SEARCH_ITEM_TEST_ID}
            underline="none"
            sx={getNavSearchItemStyles(isSelected)}
        >
            <SearchItemLogo logoUrl={logoUrl} shortDescription={shortDescription} />
            <Typography component="span" noWrap sx={{ flexGrow: 1, maxWidth: "100%", wordBreak: "break-all" }}>
                <Highlight source={shortDescription} target={query} />
            </Typography>
            {showBadge && (
                <Box sx={{ ml: 1 }}>
                    <UnderlyingBadge securityType={securityType} />
                </Box>
            )}
        </Link>
    );
};
